import React from 'react';
import { Text, localizationMaps, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

const styles = {
    row: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 5,
        marginBottom: 10
    }
};

/**
 * 
 * @param {*} string 
 * @returns 
 */
const _camelToNormalCaseNoMax = (string) => (
    // This series of functions takes converts the camelCase string to Normal Case
    string.replace('Max', '').replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())
);

/**
 * 
 * @param {*} classes 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderItem = (item, coverage) => (
    <div key={item} style={styles.row}>
        <Text small customStyle={{ flex: 1 }}>
            {item === "edMax" ? i18n.t(tokens.labels.coverage.erectileDysfunctionMedication) : localizationMaps.fromEnglish("benefits", _camelToNormalCaseNoMax(item))}
        </Text>
        {coverage[item] > 1 && <Text small>{ `$${ helpers.numberWithCommasDecimals(coverage[item]) }` }</Text>}
    </div>
);

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const CoverageBlockFull = ({ coverage, isCombined, hasMentalWellnessGrouped, isMentalWellness }) => Object.keys(coverage).map((item) => {
    // This block will return all relevant values, with mental wellness, if required
    if (isCombined && 
        !hasMentalWellnessGrouped && 
        item.includes('Max') && 
        !item.includes('Maximum')
    ) {
        return _renderItem(item, coverage);
    }

    // This block will return all relevant values, but exclude mental wellness in the case that they are combined
    if (isCombined && 
        hasMentalWellnessGrouped && 
        item.includes('Max') && 
        !item.includes('Maximum')
    ) {
        if (item.includes('psychologistMax') || item.includes('socialWorkerMax')) {
            return true;
        }

        return _renderItem(item, coverage);
    }

    // This block will return all relevant values, if not combined
    if (!isMentalWellness &&
        item.includes('Max') && 
        !item.includes('Maximum') &&
        coverage[item] > 1
    ) {
        return _renderItem(item, coverage);
    }

    if (item === 'psychotherapistMaximum' && coverage.psychotherapistMaximum > 1) {
        return (
            <div key={item} style={styles.row}>
                <Text small customStyle={{ flex: 1 }}>
                    {localizationMaps.fromEnglish("benefits", 'Psychotherapist')}
                </Text>
                <Text small>{ `$${ helpers.numberWithCommasDecimals(coverage.psychotherapistMaximum) }` }</Text>
            </div>
        );
    }

    // This block will return the mental wellness, when isMentalWellness is defined
    if (isMentalWellness && (item.includes('psychologistMax') || item.includes('socialWorkerMax'))) {
        return (
            <div key={item} style={styles.row}>
                <Text small customStyle={{ flex: 1 }}>
                    {_camelToNormalCaseNoMax(item)}{'*'}
                </Text>
            </div>
        );
    }

    return true;
});

export default (CoverageBlockFull);